import { createSlice } from '@reduxjs/toolkit';
// import { validateNationalIdNumberFormat } from '../../library/national-id';

const initialState = {
    meta: {
        pageNumber: 1,
        pageSize: 20,
        itemTotal: 0
    },
    list: [],
    selectedRole: {
        _id: undefined,
        permission: {
            _id: undefined,
            permission: undefined
        }
    },
    roleAdded: false,
    roleUpdated: false,
    roleRemoved: false,
};

const rolesSlice = createSlice({
    name: 'roles',
    initialState,
    reducers: {
        getRoles(state, action) {
            state.list = action.payload.roles;
            state.meta = action.payload.meta
        },
        viewRole(state, action) {
            state.selectedRole = action.payload;
        },
        addRole(state, action) {
            state.roleAdded = true
        },
        updateRole(state, action) {
            state.roleUpdated = true
        },
        removeRole(state, action) {
            state.roleRemoved = true
        },
        reset: (state) => initialState,
        logout: (state) => initialState,
    },
});

export const rolesActions = rolesSlice.actions;
export default rolesSlice;
